import { BroadcastFieldsForNotification, GroupFields } from '@ms/yammer-graphql';

import { LiveEventForNotification } from '../../../state/types';
import { Override } from '../../types';

import { coalesceToUndefined } from './nullable';

export interface PreNormalizedTypes {
  readonly groupId: GroupFields;
}

type PreNormalizedBroadcastForNotification = Override<LiveEventForNotification, PreNormalizedTypes>;

export const processBroadcastForNotification: (
  value: BroadcastFieldsForNotification
) => PreNormalizedBroadcastForNotification = (value) => ({
  id: value.broadcastId,
  broadcastId: value.broadcastId,
  groupId: value.group,
  title: value.title,
  status: value.status,
  teamsLiveEventType: coalesceToUndefined(value.teamsLiveEventType),
});
